import React, { useRef, useEffect, useState } from 'react';

import { Tooltip, theme } from 'antd';

import './TextEllipsis.scss';

const { useToken } = theme;
function TextEllipsis({ text }: { text: string }) {
  const { token } = useToken();

  const [isOverflow, setIsOverflow] = useState(false);
  const textParentRef = useRef<HTMLDivElement>(null);
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleResize() {
      if (textParentRef.current && textRef.current) {
        const offsetWidthParent = textParentRef.current.offsetWidth;
        const { offsetWidth } = textRef.current;

        setIsOverflow(offsetWidth > offsetWidthParent);
      }
    }

    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [text]);

  return (
    <div className="TextEllipsis">
      {isOverflow ? (
        <Tooltip
          placement="top"
          title={<div style={{ color: token.colorTextBase }}>{text}</div>}
          className="TextEllipsis"
          color="#fff"
        >
          <div className="TextEllipsis__content" ref={textParentRef}>
            <span ref={textRef}>{text}</span>
          </div>
        </Tooltip>
      ) : (
        <div className="TextEllipsis__content" ref={textParentRef}>
          <span ref={textRef}>{text}</span>
        </div>
      )}
    </div>
  );
}

export default TextEllipsis;
